import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom'; // Make sure to import BrowserRouter

import HeaderPage from './header/Header';
import LeftPanel from './LeftPanel';
import ErrorBoundary from '../ErrorBoundary';
import ChangeLog from './projectmgmt/ChangeLog';
import Footer from './footer/Footer';

class MainPage extends Component {
  render() {
    const contextPath = window.contextPath || '';
    return (
    
      <ErrorBoundary>
        <div style={{ backgroundColor: '#F9F9FB' }}>
          {/* Header section */}
          <div id="navBar">
            <HeaderPage />
          </div>


          {/* Content section */}
          <div className="content-wrapper" id="leftPanel">
            <Switch>
              {/* Rendering LeftPanel at /projectmgmt */}
              <Route path='/projectmgmt' component={LeftPanel} />
             
            </Switch>
          </div>
          <div>
            <Footer />
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

export default MainPage;


// WEBPACK FOOTER //
// src/my-jeeva/MainPage.js